// extracted by mini-css-extract-plugin
module.exports = {"paymentCheckout":"confirm_paymentCheckout__s2HUV","viewCart":"confirm_viewCart__fu_XQ","method":"confirm_method__1VMJj","addName":"confirm_addName__3qtMO"};